import React from 'react';
import styled from 'styled-components';
import ColorPicker from 'components/atoms/inputs/ColorPicker';
import TextInputAdmin from 'components/atoms/inputs/TextInputAdmin';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: space;
    flex-direction: row;
`;

const defaultPlaceholder = 'Ex #333 or #565cf0';

class ColorPickerField extends React.Component {
    render() {
        return (
            <Wrapper>
                <TextInputAdmin {...this.props} required={false}
                    placeholder={this.props.placeholder || defaultPlaceholder} />
                <ColorPicker updateColorPicker={this.props.input.onChange} color={this.props.input.value} />
            </Wrapper>
        );
    }
}

export default ColorPickerField;



// WEBPACK FOOTER //
// ./src/components/molecules/ColorPickerField.js